/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Content_TitleInputs */

const en_directory_taxonomy_use_cases_content_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create content`)
};

const zh_directory_taxonomy_use_cases_content_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Content_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建内容`)
};

/**
* | output |
* | --- |
* | "Create content" |
*
* @param {Directory_Taxonomy_Use_Cases_Content_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_content_title = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Content_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Content_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_content_title(inputs)
	return zh_directory_taxonomy_use_cases_content_title(inputs)
});
export { directory_taxonomy_use_cases_content_title as "directory.taxonomy.use-cases.content.title" }